import {
	TOGGLE_CREATE_CAMPAIGN_MODAL,
	CAMPAIGN_SAVED,
	CLOSE_DIALOG
} from "../../constants"

export const OpenCreateCampaignModal = () => {
	return {
		type: TOGGLE_CREATE_CAMPAIGN_MODAL,
		payload: {
			modal: {
				open: true
			}
		}
	}
};

export const CloseCreateCampaignModal = () => {
	return {
		type: TOGGLE_CREATE_CAMPAIGN_MODAL,
		payload: {
			modal: {
				open: false
			}
		}
	}
}

export const CampaignSaved = (campaignData) => {
	return {
		type: CAMPAIGN_SAVED,
		payload: {
			message: 'De campagne ' + campaignData.title + ' is aangemaakt'
		}
	}
};

export const closeDialog = () => {
	return {
		type: CLOSE_DIALOG
	}
};


// WEBPACK FOOTER //
// ./src/api/campaigns/actions.js